import React from "react";
import Page from "../components/Page";
import { Link } from "react-router-dom";

const Pricing = () => (
  <Page title="Pricings">
    <div className="row align-items-center text-center mt-5 mb-5">
      <div className="col">
        <span className="txt-green pb-5">Get Started</span>
        <h1 className="pb-2">Pricing</h1>
        <h3>The paid rates include ALL endpoints.</h3>
        <span className="txt-light-gray">
          <Link
            to="/contact"
            className="txt-light-gray"
            style={{ borderBottom: "1px solid" }}
          >
            Contact us
          </Link>{" "}
          to arrange custom pricing.
        </span>
      </div>
    </div>
    <div className="row row-cols-1 row-cols-lg-3 card-deck">
      <div className="col pb-5">
        <div class="card text-center ml-0 mr-0">
          <div class="card-body pl-0 pr-0">
            <h5 class="card-title">
              <span className="subtitle pb-2 txt-green">For Individuals</span>
              <h1>
                $10<span className="txt-light-gray">/Mo</span>
              </h1>
            </h5>
            <p class="card-text text-left">
              <ul className="txt-light-gray pb-5 checklist">
                <li>5,000 Messages</li>
                <li>1 API Token</li>
                <li>$7/Additional 5000 Messages</li>
                <li>Priority Email/Chat Support</li>
              </ul>
            </p>
            <p class="card-text">
              <div className="btn btn-lg btn-primary d-block d-lg-inline">
                Purchase
              </div>
            </p>
          </div>
        </div>
      </div>

      <div className="col pb-5">
        <div class="card text-center ml-0 mr-0">
          <div class="card-body pl-0 pr-0">
            <h5 class="card-title">
              <span className="subtitle pb-2 txt-green">For Teams</span>
              <h1>
                $40<span className="txt-light-gray">/Mo</span>
              </h1>
            </h5>
            <p class="card-text text-left">
              <ul className="txt-light-gray pb-5 checklist">
                <li>25,000 Messages</li>
                <li>10 API Tokens</li>
                <li>$4/Additional 5,000 Messages</li>
                <li>Priority Email / Chat Support</li>
              </ul>
            </p>
            <p class="card-text">
              <div className="btn btn-lg btn-primary d-block d-lg-inline">
                Purchase
              </div>
            </p>
          </div>
        </div>
      </div>

      <div className="col pb-5">
        <div class="card text-center ml-0 mr-0">
          <div class="card-body pl-0 pr-0">
            <h5 class="card-title">
              <span className="subtitle pb-2 txt-green">For Teams</span>
              <h1>
                $250<span className="txt-light-gray">/Mo</span>
              </h1>
            </h5>
            <p class="card-text text-left">
              <ul className="txt-light-gray pb-5 checklist">
                <li>250,000 Messages</li>
                <li>Unlimited API Tokens</li>
                <li>$2/Additional 5000 Messages</li>
                <li>Phone / Email / Chat Support</li>
              </ul>
            </p>
            <p class="card-text">
              <div className="btn btn-lg btn-primary d-block d-lg-inline">
                Purchase
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="container panels p-0">
        <div className="row align-items-center justify-content-center p-2 p-md-0">
          <div className="col-12 col-lg-6 m-5 text-center text-md-left">
            <h1>Getting Started for free</h1>
            <p>Test limited parts of our AI API for free.</p>
            <div className="btn btn-lg btn-primary d-none d-lg-inline">
              Get started
            </div>
          </div>
          <div className="col">
            <ul className="txt-light-gray checklist">
              <li>5 Messages</li>
              <li>1 API Token</li>
              <li>Access to limited endpoints</li>
            </ul>
            <div className="btn btn-lg btn-primary d-block d-lg-none">
              Get started
            </div>
          </div>
        </div>
      </div>
    </div>
  </Page>
);

export default Pricing;
